enum TaskContentTypes {
  ACW = 'ACW',
  EMAIL = 'EMAIL',
  STATUS = 'STATUS',
  CALL_RECORDING = 'CALL_RECORDING',
  CHAT_DRAFT_MESSAGE = 'CHAT_DRAFT_MESSAGE',
}

export default TaskContentTypes;
